import React, { useEffect, useState } from 'react';
import { Dialog, Input, MessagePlugin, Textarea } from 'tdesign-react';
import Form from '@/components/Form';
import { createOrganize } from '@/services/organizeService';

const { FormItem } = Form;

export default function FormModal({ visible, handleClose }) {
  const [submitting, setSubmitting] = useState(false);
  const [form] = Form.useForm();

  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      await createOrganize(values);
      MessagePlugin.success('操作成功');
      handleClose(true);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    if (!visible) {
      form.resetFields();
    }
  }, [visible, form]);

  return (
    <Dialog
      header='新增组'
      visible={visible}
      onClose={() => handleClose()}
      destroyOnClose
      confirmBtn={{ loading: submitting, content: '确定' }}
      onConfirm={() => form.submit()}
      width={550}
    >
      <Form form={form} onFinish={onSubmit} style={{ width: '80%' }}>
        <FormItem name='name' label='组名称' rules={[{ required: true, message: '请输入组名称' }]}>
          <Input placeholder='请输入组名称' />
        </FormItem>

        <FormItem name='desc' label='组描述'>
          <Textarea placeholder='请输入组描述' />
        </FormItem>
      </Form>
    </Dialog>
  );
}
